/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * queued: waiting for the runner. running: the agent is working. succeeded / failed: the turn is over (see error).
 */
export enum AgentRunStatus {
  queued = 'queued',
  running = 'running',
  succeeded = 'succeeded',
  failed = 'failed'
}
